module.exports = __webpack_public_path__ + "static/media/debian.4d763999.svg";